/**
 * Portal Manta · AjusteInput
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';

function AjusteInput({aj, onChange}){
  return (<div style={{display:'flex',gap:4,alignItems:'center',justifyContent:'center'}}>
    <select value={aj.tipo} onChange={e=>onChange({tipo:e.target.value})}
      style={{fontSize:9.5,fontWeight:700,border:'1px solid '+V.b1,borderRadius:3,padding:'2px 4px',cursor:'pointer',background:'#fff',color:V.gr,outline:'none'}}>
      <option value="%">%</option>
      <option value="R$">R$</option>
    </select>
    <input type="number" value={aj.valor||''} onChange={e=>onChange({valor:parseFloat(e.target.value)||0})}
      placeholder="0" style={{width:75,fontSize:10.5,padding:'3px 6px',border:'1px solid '+V.b1,borderRadius:3,textAlign:'right',fontFamily:'ui-monospace,monospace',outline:'none'}}/>
  </div>);
}

export { AjusteInput };
export default AjusteInput;
